webpackJsonp([224929389078309],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/car.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  query {\n      Inventory(id: "cj79sqddo1nd30154spil7cal"){\n          id\n          year\n          make\n          model\n          stockNo\n          trim\n          mileage\n          driveline\n          transmission\n      }\n  }\n  \n'], ['\n  query {\n      Inventory(id: "cj79sqddo1nd30154spil7cal"){\n          id\n          year\n          make\n          model\n          stockNo\n          trim\n          mileage\n          driveline\n          transmission\n      }\n  }\n  \n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__("./node_modules/graphql-tag/lib/graphql-tag.umd.js");
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__("./node_modules/react-apollo/react-apollo.browser.umd.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CarTest = function CarTest(props) {
	    if (!props.data.Inventory) return _react2.default.createElement(
	        'div',
	        null,
	        'Loading... '
	    );
	    var _props$data$Inventory = props.data.Inventory,
	        id = _props$data$Inventory.id,
	        year = _props$data$Inventory.year,
	        make = _props$data$Inventory.make,
	        model = _props$data$Inventory.model,
	        trim = _props$data$Inventory.trim,
	        mileage = _props$data$Inventory.mileage,
	        stockNo = _props$data$Inventory.stockNo;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: 'http://www.wheelkinetics.com/ebay/' + stockNo + '/image1.jpg', style: { width: '100px', height: 'auto', float: 'left' } }),
	        _react2.default.createElement(
	            'div',
	            null,
	            year + ' ' + make + ' ' + model + ' ' + trim
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            mileage + ' miles'
	        )
	    );
	};
	
	var query = (0, _graphqlTag2.default)(_templateObject);
	
	exports.default = (0, _reactApollo.graphql)(query, { options: function options(_ref) {
	        var pc = _ref.pathContext;
	        return { variables: { id: pc.id } };
	    } })(CarTest);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-car-js-b81a8915d72080bb4728.js